'use strict';

var proto = Element.prototype

var nativeMatches = proto.matches ||
  proto.mozMatchesSelector ||
  proto.msMatchesSelector ||
  proto.oMatchesSelector ||
  proto.webkitMatchesSelector

module.exports = nativeMatches



/*****************
 ** WEBPACK FOOTER
 ** ./~/select-parent/matches.js
 ** module id = 253
 ** module chunks = 0
 **/